function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.4884 17.8346C12.185 17.6647 11.815 17.6647 11.5116 17.8346L7.71191 19.9615C6.96731 20.3783 6.07636 19.731 6.24263 18.8941L7.09114 14.623C7.15891 14.2819 7.04457 13.93 6.78922 13.6939L3.5918 10.7373C2.96527 10.158 3.30555 9.11056 4.15295 9.01006L8.4774 8.49718C8.82273 8.45622 9.12199 8.2388 9.26766 7.92303L11.092 3.9684C11.4494 3.19358 12.5506 3.19358 12.908 3.9684L14.7323 7.92303C14.878 8.2388 15.1773 8.45622 15.5226 8.49718L19.8471 9.01006C20.6945 9.11056 21.0347 10.158 20.4082 10.7373L17.2108 13.6939C16.9554 13.93 16.8411 14.2819 16.9089 14.623L17.7574 18.8941C17.9236 19.731 17.0327 20.3783 16.2881 19.9615L12.4884 17.8346Z",
  fill: "#F7C963"
});

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.7abf403a.svg";
export { ForwardRef as ReactComponent };